module.exports = __webpack_public_path__ + "static/img/head.8d4345b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/head.png
// module id = ys0R
// module chunks = 1